<template>
  <div class="record_page">
    <Tabbar :title="$t('redesign.transactionRecord')" background="transparent" />
    <div class="top_btn_group">
      <div :class="type === 'ALL' && 'selected'" class="filter_btn" @click="switchType('ALL')">
        {{ $t('home.all') }}
      </div>
      <div :class="type === 'CASH_IN' && 'selected'" class="filter_btn" @click="switchType('CASH_IN')">
        {{ $t('home.cashIn') }}
      </div>
      <div :class="type === 'CASH_OUT' && 'selected'" class="filter_btn" @click="switchType('CASH_OUT')">
        {{ $t('basicLevel.cashOut') }}
      </div>
      <img class="filter_icon" src="@/assets/transaction/filter_icon.png" @click="showAmountFilter = true" />
    </div>
    <div class="trans_con">
      <div class="trans_mid">
        <div class="trans_mid_title" @click="showDateFilter = true">
          {{ month[currentMonthIndex] }}
          <img
            :class="$store.state.isMirroring && 'mirror'"
            class="time_filter"
            src="@/assets/transaction/guide_arrow.png"
          />
        </div>
        <p :class="$store.state.isMirroring && 'mirror'" class="trans_mid_con">{{ cashInOutText }}</p>
      </div>
      <div class="trans_bottom" ref="transRef">
        <div v-if="activities.length === 0 && loading" class="loading_box">
          {{ $t('home.loading') }}
        </div>
        <van-list
          v-if="activities.length > 0 || loading"
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          :finished-text="$t('home.noMore')"
          :error-text="$t('home.reload')"
          @load="onLoad"
        >
          <van-cell
            class="transaction_item_box"
            v-for="item in activities"
            :key="item.activityNo"
            @click="toTransactionDetail(item.activityNo)"
          >
            <div class="transaction_item">
              <img
                v-if="cashWithdraw.indexOf(item.type) > -1"
                class="transaction_item_icon"
                src="@/assets/transaction/transactions_list_icon_cashout.png"
              />
              <img
                v-if="cashWithdrawRefund.indexOf(item.type) > -1"
                class="transaction_item_icon"
                src="@/assets/transaction/transactions_list_icon_cashout.png"
              />
              <img
                v-if="cashRecharge.indexOf(item.type) > -1"
                class="transaction_item_icon"
                src="@/assets/transaction/transactions_list_icon_expense.png"
              />
              <img
                v-if="cashIn.indexOf(item.type) > -1"
                class="transaction_item_icon"
                src="@/assets/transaction/transactions_list_icon_cashin.png"
              />
              <img
                v-if="cashOut.indexOf(item.type) > -1"
                class="transaction_item_icon"
                src="@/assets/transaction/transactions_list_icon_expense.png"
              />
              <img
                v-if="cashTransfer.indexOf(item.type) > -1"
                class="transaction_item_icon"
                src="@/assets/transaction/transactions_list_icon_transfer.png"
              />
              <div class="transaction_item_content">
                <div v-if="item.type === 0" class="transaction_item_des">
                  {{ $t('home.receivedFrom') + ': ' + item.relatedUser + ' (' + item.relatedPhone + ')' }}
                </div>
                <div v-if="item.type === 1" class="transaction_item_des">
                  {{ $t('home.transferredTo') + ': ' + item.relatedUser + ' (' + item.relatedPhone + ')' }}
                </div>
                <div v-if="item.type === 20" class="transaction_item_des">
                  {{ $t('home.fee') + ' ' + item.relatedPhone }}
                </div>
                <div v-if="[0, 1, 20].indexOf(item.type) === -1" class="transaction_item_des">
                  {{ item.remark }}
                </div>
                <div class="transaction_item_time">{{ formatDate(item.createTime) }} (GMT +0)</div>
              </div>
              <div class="transaction_item_amount">
                <span>
                  {{
                    (transOut.indexOf(item.type) > -1 ? '-' : '') +
                    new Intl.NumberFormat('en', {
                      style: 'currency',
                      currency: 'USD',
                      currencyDisplay: 'symbol',
                      minimumFractionDigits: 0
                    }).format(item.amount)
                  }}
                </span>
              </div>
            </div>
          </van-cell>
        </van-list>
        <NoData v-else class="no_data_box" />
      </div>
      <TransactionAmountFilter
        v-model="showAmountFilter"
        :cur-min-amount="minAmount"
        :cur-max-amount="maxAmount"
        @setAmount="setAmount"
      />
      <TransactionDateFilter
        v-model="showDateFilter"
        :cur-begin-time="beginTime"
        :cur-end-time="endTime"
        @setTime="setTime"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Tabbar from '@/components/Tabbar.vue'
import NoData from '@/components/noData.vue'
import TransactionAmountFilter from '@/components/Transaction/TransactionAmountFilter.vue'
import TransactionDateFilter from '@/components/Transaction/TransactionDateFilter.vue'
import { formatDate } from '@/utils'

export default {
  name: 'TransactionRecord',
  components: {
    Tabbar,
    NoData,
    TransactionAmountFilter,
    TransactionDateFilter
  },
  data() {
    return {
      currentMonthIndex: 0,
      currentItemYear: moment().startOf('year').format('YYYY'),
      totalMonthTrans: [],
      activities: [],
      beginTime: '',
      endTime: '',
      minAmount: '',
      maxAmount: '',
      page: 1,
      type: 'ALL',
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      withdrawMethods: [],
      withdrawTypes: [
        undefined,
        undefined,
        undefined,
        'Bank Card',
        'GCash',
        'PayMaya',
        'Coins.ph',
        'GoPay',
        'OVO',
        'DANA',
        'PayPal',
        'Epay'
      ],
      // 交易图标
      cashWithdraw: [9, 14],
      cashWithdrawRefund: [10, 16],
      cashIn: [7, 8, 19],
      cashOut: [4, 18],
      cashTransfer: [0, 1, 20],
      cashRecharge: [23],
      // 用户展示资金前的减号
      transOut: [1, 20, 9, 14, 4, 18, 23],
      loading: true,
      finished: false,
      error: false,
      tempStatus: false,
      showAmountFilter: false,
      showDateFilter: false
    }
  },
  computed: {
    getCashInAmount: function () {
      const thisYear = this.currentItemYear
      for (const item of this.totalMonthTrans) {
        if (Number(item.month) === this.currentMonthIndex + 1 && thisYear === item.year) {
          return new Intl.NumberFormat('en', {
            style: 'currency',
            currency: 'USD',
            currencyDisplay: 'symbol'
          }).format(item.totalCashInAmount || 0)
        }
      }
      return '$0.00'
    },
    getCashOutAmount: function () {
      const thisYear = this.currentItemYear
      for (const item of this.totalMonthTrans) {
        if (Number(item.month) === this.currentMonthIndex + 1 && thisYear === item.year) {
          return new Intl.NumberFormat('en', {
            style: 'currency',
            currency: 'USD',
            currencyDisplay: 'symbol'
          }).format(item.totalCashOutAmount || 0)
        }
      }
      return '$0.00'
    },
    cashInOutText() {
      let text = ''
      text += ['ALL', 'CASH_IN'].indexOf(this.type) > -1 ? this.$t('home.cashIn') + ' ' + this.getCashInAmount : ''
      text += ['ALL'].indexOf(this.type) > -1 ? ', ' : ''
      text +=
        ['ALL', 'CASH_OUT'].indexOf(this.type) > -1 ? this.$t('basicLevel.cashOut') + ' ' + this.getCashOutAmount : ''
      return text
    }
  },
  mounted() {
    this.getTransactions()
    this.onLoad()
    window.addEventListener('scroll', this.transScroll, true)
  },
  methods: {
    formatDate,
    // 获取用户月度交易金额
    getTransactions() {
      const $this = this
      if (!this.endTime) {
        this.currentMonthIndex = Number(moment().utcOffset(0).endOf('day').format('MM')) - 1
      } else {
        this.currentMonthIndex = Number(moment(this.endTime).format('MM')) - 1
      }
      this.$http
        .get(window.serverPath + '/api/transactions/totalAmountByMonth')
        .then((res) => {
          if (res.data && res.data.code === '200') {
            $this.totalMonthTrans = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 交易记录下方类型tab切换
    switchType(value) {
      this.type = value
      // 清空 this.activities 并重新请求数据
      this.activities = []
      this.page = 1
      this.currentMonthIndex = 0
      this.loading = false
      this.finished = false
      this.error = false
      this.onLoad()
      window.addEventListener('scroll', this.transScroll, true)
    },
    setAmount(amounts) {
      this.minAmount = amounts.minAmount
      this.maxAmount = amounts.maxAmount
      this.activities = []
      this.page = 1
      this.currentMonthIndex = 0
      this.loading = false
      this.finished = false
      this.error = false
      this.onLoad()
      window.addEventListener('scroll', this.transScroll, true)
    },
    setTime(times) {
      this.beginTime = times.beginTime
      this.endTime = times.endTime
      this.activities = []
      this.page = 1
      this.currentMonthIndex = 0
      this.loading = false
      this.finished = false
      this.error = false
      this.onLoad()
    },
    // 交易记录列表加载
    onLoad() {
      this.getActivities()
      this.page++
    },
    //  获取用户交易记录
    getActivities() {
      this.loading = true
      const $this = this
      const query = []
      if (this.beginTime) {
        query.push('beginTime=' + moment(this.beginTime).format('YYYY-MM-DD HH:mm:ss'))
      }
      if (!this.endTime) {
        this.currentMonthIndex = Number(moment().utcOffset(0).endOf('day').format('MM')) - 1
      } else {
        query.push('endTime=' + moment(this.endTime).format('YYYY-MM-DD HH:mm:ss'))
        this.currentMonthIndex = Number(moment(this.endTime).format('MM')) - 1
      }
      if (this.minAmount) {
        query.push('minAmount=' + this.minAmount)
      }
      if (this.maxAmount) {
        query.push('maxAmount=' + this.maxAmount)
      }
      query.push('pageSize=20&page=' + this.page)
      query.push('type=' + this.type)

      this.$http
        .get(window.serverPath + '/api/transactions?' + query.join('&'))
        .then((res) => {
          $this.loading = false
          if (res.data && res.data.code === '200') {
            $this.activities = $this.activities.concat(res.data.data.list)
            if ($this.page > res.data.data.totalPages) {
              $this.finished = true
            } else {
              $this.finished = false
            }
          } else {
            $this.error = true
          }
        })
        .catch((err) => {
          $this.loading = false
          $this.error = true
          console.log(err)
        })
    },
    transScroll() {
      const domEl = this.$refs.transRef

      const scrollTop = domEl.scrollTop
      const docEl = document.documentElement

      const fontSize = docEl.style.fontSize.replace('px', '')
      const index = Math.floor(scrollTop / (Number(fontSize) * 0.7) - 0.2)
      const item = this.activities[index]
      if (item) {
        this.currentItemYear = moment(item.createTime).format('YYYY')
        this.currentMonthIndex = Number(moment(item.createTime).format('MM')) - 1
      }
    },
    toTransactionDetail(activityNo) {
      this.$router.push({
        name: 'TransactionDetail',
        query: { activityNo: activityNo }
      })
    }
  }
}
</script>

<style scoped>
.record_page {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #43d77d 0%, #efefef 50%), rgba(0, 0, 0, 0.9);
}

.top_btn_group {
  margin-top: 0.12rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: 0 0.16rem;
}

.filter_btn {
  min-width: 0.6rem;
  height: 0.36rem;
  padding: 0 0.12rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.08rem;
  background: #fff;
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  margin-inline-end: 0.12rem;
}

.filter_btn.selected {
  color: #3fbb70;
  font-weight: 600;
}

.filter_icon {
  margin-inline-start: auto;
  width: 0.36rem;
  height: 0.36rem;
}

.trans_con {
  margin: 0.16rem 0.16rem 0.28rem;
  display: flex;
  width: calc(100% - 0.32rem);
  padding: 0 0.2rem;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  border-radius: 0.08rem;
  background: #fff;
  height: calc(100% - 1.38rem);
}

.trans_mid {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 0.01rem solid #efefef;
  box-sizing: border-box;
  padding: 0.12rem 0;
  margin: 0 0.2rem;
}

.trans_mid_title {
  width: 100%;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 0.04rem;
}

.time_filter {
  width: 0.2rem;
  height: 0.2rem;
  margin-inline-start: 0.04rem;
}

.time_filter.mirror {
  transform: rotateY(180deg);
}

.trans_mid_con {
  width: 100%;
  text-align: left;
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 0.2rem;
}

.trans_mid_con.mirror {
  text-align: right;
}

.trans_bottom {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}

.trans_bottom::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.loading_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.12rem;
  color: #969799;
}

.transaction_item_box {
  padding: 0.12rem 0;
  box-sizing: border-box;
  width: 100%;
  border-bottom: 0.01rem solid #efefef;
}

.transaction_item {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.transaction_item_icon {
  width: 0.3rem;
  height: 0.3rem;
  display: block;
  margin-inline-end: 0.08rem;
  flex-shrink: 0;
}

.transaction_item_content {
  width: 2.3rem;
}

.transaction_item_des {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.transaction_item_time {
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.transaction_item_amount {
  margin-inline-start: auto;
  flex-shrink: 0;
  font-weight: 600;
}

.no_data_box {
  height: 100%;
}
</style>

<style>
.van-cell::after {
  display: none;
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
</style>



// WEBPACK FOOTER //
// src/views/TransactionRecord.vue